module.exports = __webpack_public_path__ + "static/media/criativos_masculino_beleza.ca855961.jpg";